import script from "./b-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-text.vue?vue&type=script&lang=ts&setup=true"

import "./b-text.vue?vue&type=style&index=0&id=949eeb7a&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-949eeb7a"]])

export default __exports__